import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import AOS from 'aos';
import { initSeo } from '@/utils/seo';

//import "@/assets/theme/styles.css";

const app = createApp(App)

//app.use(createPinia())
app.use(router)

// Site-wide structured data (RealEstateAgent). Per-page tags are applied by
// the router's afterEach hook in src/router/index.js.
initSeo();

app.mount('#app')

// Initialize AOS
AOS.init();
